import Agent from './agent'

const agent = new Agent()

export const groupingService = {
  one: (params) => agent.get(`/layout`, { params }),
  update: (data) => agent.post(`/layout`, { data }),
}
